import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/png.png'
import _imports_1 from '@/assets/images/jpg.png'
import _imports_2 from '@/assets/images/txt.png'
import _imports_3 from '@/assets/images/pdf.png'
import _imports_4 from '@/assets/images/xl4.png'
import _imports_5 from '@/assets/images/doc.png'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_7 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_8 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = { class: "d-flex justify-content-between" }
const _hoisted_11 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_12 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_13 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_14 = { class: "card-body p-4" }
const _hoisted_15 = { class: "d-flex justify-content-between" }
const _hoisted_16 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_17 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_18 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_19 = { class: "card-body p-4" }
const _hoisted_20 = { class: "d-flex justify-content-between" }
const _hoisted_21 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_22 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_23 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_24 = { class: "card-body p-4" }
const _hoisted_25 = { class: "d-flex justify-content-between" }
const _hoisted_26 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_27 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_28 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_29 = { class: "card-body p-4" }
const _hoisted_30 = { class: "d-flex justify-content-between" }
const _hoisted_31 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_32 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_33 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_34 = { class: "card-body p-4" }
const _hoisted_35 = { class: "d-flex justify-content-between" }
const _hoisted_36 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_37 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_38 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_39 = { class: "card-body p-4" }
const _hoisted_40 = { class: "d-flex justify-content-between" }
const _hoisted_41 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_42 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_43 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_44 = { class: "card-body p-4" }
const _hoisted_45 = { class: "d-flex justify-content-between" }
const _hoisted_46 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_47 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_48 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_49 = { class: "card-body p-4" }
const _hoisted_50 = { class: "d-flex justify-content-between" }
const _hoisted_51 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_52 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_53 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_54 = { class: "card-body p-4" }
const _hoisted_55 = { class: "d-flex justify-content-between" }
const _hoisted_56 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_57 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_58 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_59 = { class: "card-body p-4" }
const _hoisted_60 = { class: "d-flex justify-content-between" }
const _hoisted_61 = { class: "dropdown action-opt ms-2 position-relative top-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault1"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, _cache[0] || (_cache[0] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_0 + "\" alt=\"png\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Projects </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">159 Files</span><span class=\"fs-13 text-secondary\">4.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault2"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, _cache[3] || (_cache[3] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_1 + "\" alt=\"jpg\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Documents </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">522 Files</span><span class=\"fs-13 text-secondary\">5.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault3"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, _cache[6] || (_cache[6] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_2 + "\" alt=\"txt\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\">Media</span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">995 Files</span><span class=\"fs-13 text-secondary\">7.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault4"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, _cache[9] || (_cache[9] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_3 + "\" alt=\"txt\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Applications </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">39 Files</span><span class=\"fs-13 text-secondary\">3.8 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault5"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, _cache[12] || (_cache[12] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_4 + "\" alt=\"xl4\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> ET Template </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">159 Files</span><span class=\"fs-13 text-secondary\">4.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault6"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, _cache[15] || (_cache[15] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_5 + "\" alt=\"doc\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> React Template </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">357 Files</span><span class=\"fs-13 text-secondary\">8.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault7"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, _cache[18] || (_cache[18] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_0 + "\" alt=\"png\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Material UI </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">159 Files</span><span class=\"fs-13 text-secondary\">4.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault8"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, _cache[21] || (_cache[21] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_1 + "\" alt=\"jpg\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> WP Theme </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">522 Files</span><span class=\"fs-13 text-secondary\">5.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault9"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_46, _cache[24] || (_cache[24] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_2 + "\" alt=\"txt\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Personal Photos </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">995 Files</span><span class=\"fs-13 text-secondary\">7.5 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault10"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_51, _cache[27] || (_cache[27] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_3 + "\" alt=\"txt\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Mobile Apps </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">39 Files</span><span class=\"fs-13 text-secondary\">3.8 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault11"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_56, _cache[30] || (_cache[30] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[32] || (_cache[32] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_4 + "\" alt=\"xl4\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Important Files </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">75 Files</span><span class=\"fs-13 text-secondary\">2.2 GB</span></div>", 2))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "form-check" }, [
              _createElementVNode("input", {
                class: "form-check-input p-0",
                type: "checkbox",
                value: "",
                id: "flexCheckDefault12"
              })
            ], -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_61, _cache[33] || (_cache[33] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"py-4\"><img src=\"" + _imports_1 + "\" alt=\"jpg\"><span class=\"fs-15 fw-bold text-secondary d-block mt-3\"> Angular Template </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">357 Files</span><span class=\"fs-13 text-secondary\">8.5 GB</span></div>", 2))
        ])
      ])
    ])
  ]))
}